import { render, staticRenderFns } from "./MoneyBank.vue?vue&type=template&id=611ffc31&scoped=true&"
import script from "./MoneyBank.vue?vue&type=script&lang=js&"
export * from "./MoneyBank.vue?vue&type=script&lang=js&"
import style0 from "./MoneyBank.vue?vue&type=style&index=0&id=611ffc31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ffc31",
  null
  
)

export default component.exports